import {
  FaReact, FaPython, FaHtml5, FaCss3Alt, FaJs, FaPhp
} from 'react-icons/fa';
import {
  SiPostgresql, SiFlask, SiMysql, SiCplusplus,
  SiPandas, SiNumpy, SiBootstrap, SiStreamlit
} from 'react-icons/si';

// Map of technology names to their respective react-icons components
const techIconMap = {
  // Frontend
  react: FaReact,
  html: FaHtml5,
  css: FaCss3Alt,
  javascript: FaJs,
  bootstrap: SiBootstrap,

  // Backend
  python: FaPython,
  php: FaPhp,
  flask: SiFlask,
  
  // Databases
  postgresql: SiPostgresql,
  mysql: SiMysql,

  // Data Science & ML
  pandas: SiPandas,
  numpy: SiNumpy,
  streamlit: SiStreamlit,

  // Programming Languages
  "c++": SiCplusplus
};

function TechStack({ technologies, className = '' }) {
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {technologies.map((tech, index) => {
        // Convert to lowercase and remove spaces for matching
        const normalizedName = tech.name.toLowerCase().replace(/\s+/g, '');
        const Icon = tech.icon || techIconMap[normalizedName];
        
        return (
          <div
            key={index}
            className="pill-tag"
          >
            {Icon && <Icon className="h-4 w-4 text-emerald-200" />}
            <span>{tech.name}</span>
          </div>
        );
      })}
    </div>
  );
}

export default TechStack; 